import { ajax } from "@/plugins/ajax";

export default {
  namespaced: true,
  state: {
    list: []
  },
  getters: {
    list: state => state.list
  },

  actions: {
    fetch({ commit, dispatch }) {
      return ajax.get("Promotion/api/Vouchers").then(r => {
        commit("setList", r.data.data);
      });
    },
    create({ commit, dispatch }, model) {
      return ajax.post("/Promotion/api/Vouchers", model).then(r => {});
    },
    createDiscount({ commit, dispatch }, model) {
      return new Promise((resolve, reject) => {
        ajax
          .post("/Promotion/api/PublicDiscountCodes", model)
          .then(r => {
            resolve(r.data);
          })
          .catch(e => {
            reject(e.response.data);
          });
      });
    },
    editDiscount({ commit, dispatch }, model) {
      return ajax.put("Promotion/api/PublicDiscountCodes", model);
    },
    promotionProducts({ commit, dispatch }, model) {
      return new Promise(resolve => {
        ajax.get("/Promotion/api/PromotionProducts?" + model).then(r => {
          commit("setList", r.data);
          resolve(r.data);
        });
      });
    },
    createSetting({ commit, dispatch }, model) {
      return ajax.put("/Promotion/api/Discounts/setting", model).then(r => {});
    },
    removeDiscount({ commit, dispatch }, id) {
      return ajax
        .delete(
          "/Promotion/api/Discounts",
          { data: { discountId: id } },
          { headers: { "Content-Type": "application/json" } }
        )
        .then(() => {
          // dispatch("fetch");
        });
    }
  },
  mutations: {
    setList(state, data) {
      state.list = data;
    }
  }
};
